import React from 'react';
import { ContentBox } from '../ContentBox/ContentBox';

interface IProps {
  loanSelected: any;
}

export const BoxLoanDetails: React.FC<IProps> = ({ loanSelected }: IProps) => {

  const purpose = loanSelected?.purpose;
  const type = loanSelected?.type;
  const amortization = loanSelected?.salesforceData?.details?.amortization ? loanSelected?.salesforceData?.details?.amortization : (loanSelected?.type === 'Rental' ? '30 year' : 'Interest Only')
  const lien = '1st Position';

  return (
    <ContentBox
      label={'Loan Details'}
      content={[
        { field: 'Loan Purpose', value: purpose },
        { field: 'Loan Type', value: type },
        { field: 'Amortization', value: amortization },
        { field: 'Lien', value: lien },
      ]}
    />
  );
}